<template>
  <div>
    <FloatLabel variant="on">
      <Textarea
        :id="`textarea-${name || 'default'}`"
        v-model="internalValue"
        :name="name"
        :disabled="disabled"
        :readonly="readOnly"
        :auto-resize="autoResize"
        :rows="rows"
        :class="['w-100 p-inputtext-sm', { 'p-invalid': error }]"
        :style="`min-height: ${minHeight}px`"
        @change="handleChange"
      />
      <label :for="`textarea-${name || 'default'}`">{{ placeholder }}</label>
    </FloatLabel>

    <small
      v-if="error"
      class="font-size-sm text-red mt-1"
    >{{ error }}</small>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Textarea from 'primevue/textarea';
import FloatLabel from 'primevue/floatlabel'

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  error: {
    type: String,
    default: null
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  readOnly: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    required: true,
  },
  minHeight: {
    type: [String, Number],
    default: null
  },
  autoResize: {
    type: Boolean,
    default: true
  },
  rows: {
    type: Number,
    default: 3
  }
});

const emit = defineEmits(["update:modelValue", "onChange"]);

// مدیریت دو طرفه دیتا (v-model)
const internalValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const handleChange = (event) => {
  emit('onChange', event.target.value);
};
</script>